import React, { useEffect, useState } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { GetAllTrustedPartnerforWeb } from "../../APIs/APIHelperforWeb";
import { partners } from "../../data/brands";
import { BaseURL } from "../../APIs/APIUrls";
export default function BrandsSlider() {
  const [partnerLogos, setPartnerLogos] = useState(partners);

  useEffect(() => {
    const resolveLogoUrl = (logoPath) => {
      if (!logoPath) return "";
      const cleanedPath = String(logoPath).replace(/\\/g, "/");
      if (/^https?:\/\//i.test(cleanedPath) || cleanedPath.startsWith("/")) {
        return cleanedPath;
      }
      return `/${cleanedPath}`;
    };

    const loadPartners = async () => {
      const response = await GetAllTrustedPartnerforWeb();
      if (!Array.isArray(response) || !response.length) {
        return;
      }

      const mappedPartners = response
        .map((item) => ({
          src: resolveLogoUrl(item?.Logo),
          width: 160,
          height: 80,
          alt: item?.AltText || item?.PartnerName || "Trusted Partner",
        }))
        .filter((item) => !!item.src);

      if (mappedPartners.length) {
        setPartnerLogos(mappedPartners);
      }
    };

    loadPartners();
  }, []);





  return (
    <Swiper
      className="swiper tf-sw-partner"
      slidesPerView={6} // Default slides per view for large screens
      spaceBetween={15} // Default space between slides
      loop
      modules={[Autoplay]}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      speed={500}
      breakpoints={{
        1024: {
          slidesPerView: 6, // Large screens (Desktop)
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 4, // Tablets
          spaceBetween: 30,
        },
        575: {
          slidesPerView: 3, // Smaller mobile screens
          spaceBetween: 15,
        },
        0: {
          slidesPerView: 2, // Standard mobile screens
          spaceBetween: 15,
        },
      }}
    >
      {partnerLogos.map((partner, index) => (
        <SwiperSlide key={index} className="swiper-slide">
          <div className="partner-item">
            <img
              src={BaseURL + partner.src}
              width={partner.width}
              height={partner.height}
              alt={partner.alt || `Partner ${index + 1}`}
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
